import { useMemo, useState } from "react";

/**
 * useBoolean Hook 管理一个布尔值状态。
 * @param {boolean} [initialValue=false] - 初始布尔值
 * @returns {[boolean, {setTrue: function, setFalse: function, toggle: function, setValue: function, getValue: function}]}
 */
function useBoolean(initialValue = false) {
  const [boolean, setBoolean] = useState(initialValue);

  const active = useMemo(() => {
    const setTrue = () => setBoolean(true);
    const setFalse = () => setBoolean(false);
    const toggle = () => setBoolean((state) => !state);
    const setValue = (value) => setBoolean(value);
    const getValue = () => boolean;
    return {
      toggle,
      setTrue,
      setFalse,
      setValue,
      getValue,
    };
  }, [boolean]);

  return [boolean, active];
}

export default useBoolean;
